import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILoginResponse } from "interfaces/ApiInterface/ILoginFormData";

interface LoginPageState {
  User: ILoginResponse | null;
}

const initialState: LoginPageState = {
  User: null,
};

const loginResponseSlice = createSlice({
  name: "loginPageResponse",
  initialState,
  reducers: {
    setLoginResponseData: (state, action: PayloadAction<ILoginResponse>) => {
      state.User = action.payload;
    },
  },
});

export const { setLoginResponseData } = loginResponseSlice.actions;
export default loginResponseSlice.reducer;